import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CountUp from 'react-countup';
//import linkResolver from '../../config/linkResolver';
import { getTinyImage } from '../../utils/prismic';

const HeroContainer = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--size-space-medium) var(--size-space-tiny);
`;

const StatContainer = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  max-width: var(--screen-desktop-big);
`;
const StatCounter = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 0;
  align-items: center;
  justify-content: center;
  margin: var(--size-space-tiny) var(--size-space-small);
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    position: relative;
    z-index: 5;
    display: block;
    text-align: center;
    max-width: none;
  }
  h4,
  h6 {
    color: white;
    //text-transform: uppercase;
  }
  h4 {
    font-size: 2.4rem;
    line-height: 4rem;
    font-weight: bold;
    letter-spacing: 0.16rem;
  }
  h6 {
    letter-spacing: 0.4rem;
  }
  img {
    margin-top: var(--size-space-small);
    margin-bottom: var(--size-space-small);
    margin-right: var(--size-space-tiny);
    &:last-child {
      margin-left: var(--size-space-tiny);
    }
  }
`;

const HeroStats = ({ input }) => {
  //console.log(input.primary);

  const stats = input.items.map((x, index) => {
    const prefixText = x.counter_prefix ? x.counter_prefix + ' ' : null;
    const suffixText = x.counter_suffix ? ' ' + x.counter_suffix : null;

    return (
      <StatContainer key={x + index}>
        <StatCounter color={x.color}>
          <h6>{x.title}</h6>
          <h4>
            <span
              style={{
                color: x.color,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {prefixText}
              {x.icon && x.icon.url ? (
                <img
                  src={getTinyImage(x.icon).url}
                  alt={getTinyImage(x.icon).alt}
                  height="56"
                />
              ) : null}
              {x.counter_start && x.counter_end && (
                <span style={{ minWidth: '100px', marginRight: '.8rem' }}>
                  <CountUp
                    start={x.counter_start}
                    end={x.counter_end}
                    duration={300}
                    separator=","
                    decimals={0}
                    decimal="."
                    //prefix={prefixText}
                    //suffix={suffixText}
                  />
                </span>
              )}
              {suffixText}
            </span>
          </h4>
          <span
            dangerouslySetInnerHTML={{
              __html: x.description.html,
            }}
          />
        </StatCounter>
      </StatContainer>
    );
  });

  return <HeroContainer>{stats}</HeroContainer>;
};

HeroStats.propTypes = {
  input: PropTypes.object.isRequired,
};

export default HeroStats;
